import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7FIAInstrumentsEdit } from "./edit";
import { A7FIAInstrumentsTable } from "./table";

export default function A7FIAInstruments() {
  useEffect(() => {
    setDocumentTitle("Quantilia | FIA Instruments Financiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIAInstrumentsEdit />} />
      <Route index element={<A7FIAInstrumentsTable />} />
    </Routes>
  );
}
